

import { useShow } from "@/contexts/ShowContext"
import AssetsEditor from "@/components/AssetsEditor"

export default function ShowAssetsPage() {
    const {show} = useShow()
    
    return (
        <AssetsEditor component={show} scope='show' />
    );
}
